import { memo, useEffect, useRef } from "react";
import { Marker, Tooltip } from "react-leaflet";

const BlockMarker = memo(
  ({
    location,
    convertedPositionObj,
    metaData,
    block,
    blockClickHandler,
    reactIcon,
    rotateMarker,
    markerRefs,
    setPopUpDetails,
    isBlockRackModalOpen,
    hoveredLocation,
    setHoveredLocation,
  }) => {
    const markerRef = useRef({});

    useEffect(() => {
      markerRefs.current[location] = markerRef.current;

      return () => {
        delete markerRefs.current[location];
      };
    }, [markerRef.current, location]);

    useEffect(() => {
      if (!isBlockRackModalOpen && hoveredLocation === location) {
        const iconEl = markerRefs.current[location]?._icon;
        if (iconEl) {
          iconEl.classList.add("outline-yellow");
        }
      } else {
        const iconEl = markerRefs.current[location]?._icon;
        if (iconEl) {
          iconEl.classList.remove("outline-yellow");
        }
      }
    }, [isBlockRackModalOpen, hoveredLocation, location]);

    return (
      <Marker
        ref={markerRef}
        eventHandlers={{
          click: ({ target: { _map: map }, originalEvent }) => {
            blockClickHandler(block, "block");
            const latLng = map.mouseEventToLatLng(originalEvent);
            setPopUpDetails({ latLng, location });
          },
          mouseover: () => {
            setHoveredLocation(location);
            const iconEl = markerRef?.current?._icon;

            if (iconEl) {
              const iconEl = markerRef.current?._icon;
              Object.entries(markerRefs.current).forEach(([_, ref]) => {
                if (ref?.getTooltip()) ref.closeTooltip();
              });
              markerRef.current?.openTooltip();
              void iconEl.offsetHeight;
              if (iconEl) {
                iconEl.classList.add("outline-yellow");
              }
            }
          },
          mouseout: () => {
            setHoveredLocation(null);
            const iconEl = markerRef.current?._icon;
            markerRef.current?.closeTooltip();
            if (iconEl) {
              iconEl.classList.remove("outline-yellow");
            }
          },
        }}
        position={convertedPositionObj}
        icon={reactIcon}
        rotationAngle={rotateMarker(
          metaData.angle,
          metaData.locationOrientation,
          metaData.positionOrientation
        )}
      >
        <Tooltip
          sticky
          direction="top"
          permanent={false}
          interactive={false}
          autoPan={false}
          autoClose={false}
        >
          {location}
        </Tooltip>
      </Marker>
    );
  }
);

export default BlockMarker;
